module.exports = __webpack_public_path__ + "img/scan.762cf032.svg";